import { CountryEnv } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_JP_GU || "gu.jp.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_JP_GU || 0,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_JP_GU || 0,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_JP_GU || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_JP_GU || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_JP_GU || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_JP_GU || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_GU || "",
  faqUrl: "https://faq.gu-global.com/",
  showAboutApp: true
};

export default _countryEnv;
